import { Button, Flex, Group, Text } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form/lib/types'
import ButtonFilter from '@v2/commons/components/FilterButton/FilterButton.component'
import FilterTextDebounce from '@v2/commons/components/FilterTextInput/FilterTextDebounce.component.tsx'
import SearchInput from '@v2/commons/components/SearchInput/SearchInput'

import { Icons } from 'src/common/components'

import { type ILocationsFilter } from '../../location.types'
import styles from './locations-filters.module.scss'

interface UsersTableFilterProps {
  locationsFiltersForm: UseFormReturnType<ILocationsFilter>
  totalRecords: number
  filtersOpen: boolean
  setFiltersOpen: React.Dispatch<React.SetStateAction<boolean>>
  activeProgramButtonFilter: string
  setActiveProgramButtonFilter: (value: string) => void
}

const LocationsTableFilter = ({
  locationsFiltersForm,
  totalRecords,
  filtersOpen,
  setFiltersOpen,
  activeProgramButtonFilter,
  setActiveProgramButtonFilter,
}: UsersTableFilterProps) => {
  const handleClearFilters = () => {
    locationsFiltersForm.reset()
    setActiveProgramButtonFilter('')
  }

  const handleChangeValue = (
    path: keyof ILocationsFilter,
    value: ILocationsFilter[keyof ILocationsFilter],
  ) => {
    locationsFiltersForm.setFieldValue(path, value)
  }

  const handleChangeValueProgram = (value: string) => {
    setActiveProgramButtonFilter(value)
    locationsFiltersForm.setFieldValue('program', value)
  }

  return (
    <>
      <Flex justify="space-between" align="center" mb="30px">
        <ButtonFilter
          onClick={() => setFiltersOpen((prev) => !prev)}
          isOpen={filtersOpen}
        />
        <Text lh="26px" size="18px">
          Total Records: {totalRecords}
        </Text>
      </Flex>
      {filtersOpen && (
        <form
          style={{ marginBottom: '30px' }}
          onSubmit={(e) => {
            e.preventDefault()
          }}
        >
          <Group
            preventGrowOverflow={false}
            grow={true}
            classNames={{ root: styles['group-root'] }}
          >
            <SearchInput
              variant="unstyled"
              form={locationsFiltersForm}
              placeholder="zipCode"
              name="zipCode"
            />

            <Flex miw="50%" justify="flex-end" gap="sm">
              <Button
                variant={
                  activeProgramButtonFilter === '' ? 'filled' : 'outline'
                }
                onClick={() => handleChangeValueProgram('')}
                type="button"
              >
                All Locations
              </Button>

              <Button
                variant={
                  activeProgramButtonFilter === 'DENTAL' ? 'filled' : 'outline'
                }
                onClick={() => handleChangeValueProgram('DENTAL')}
                type="button"
                leftSection={<Icons.Dental width={30} />}
              >
                Dental
              </Button>

              <Button
                variant={
                  activeProgramButtonFilter === 'VISION' ? 'filled' : 'outline'
                }
                onClick={() => handleChangeValueProgram('VISION')}
                type="button"
                leftSection={<Icons.Eye width={30} />}
              >
                Vision
              </Button>
            </Flex>

            <Flex miw="50%" justify="flex-end">
              <Button
                variant="transparent"
                classNames={{ root: styles['clear-button-root'] }}
                onClick={handleClearFilters}
                type="button"
              >
                Clear All
              </Button>
            </Flex>
          </Group>
        </form>
      )}
    </>
  )
}

export default LocationsTableFilter
